import { Alert, Text } from '@chakra-ui/react'
import type { ActiveCanvassingDto } from '../../../types/campaign'

/**
 * [Canvass this, CT-17] Warns the organizer that someone is mid-walk on the turfs about to be recut.
 * A warning only — it never disables an action. MinutesAgo is the server's value.
 */
export function ActiveCanvassingAlert({ data }: { data: ActiveCanvassingDto | undefined }) {
  if (!data || !data.applies || data.turfs.length === 0) return null
  const lines = data.turfs.flatMap((t) =>
    t.canvassers.map((c) => ({
      key: `${t.turfId}:${c.grantId}`,
      text: `${t.turfLabel} — ${c.fullName}, last door ${c.minutesAgo < 1 ? 'just now' : `${c.minutesAgo} min ago`}. Recutting may disrupt their walk.`,
    })),
  )
  if (lines.length === 0) return null
  return (
    <Alert.Root status="warning" borderRadius="md" py={2} alignItems="flex-start">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title>Canvassing in progress</Alert.Title>
        <Alert.Description>
          {lines.map((l) => (
            <Text key={l.key} fontSize="sm">{l.text}</Text>
          ))}
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
